module.exports = __webpack_public_path__ + "img/遵化钢铁.c89eda12.jpg";